import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UploadedDateFilter } from "~/components/Filters/DateFilter/UploadedDateFilter";
import { SingleFilterContainer } from "~/components/Filters/SingleFilters/SingleFilterContainer";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
import { setUploadedDateFilterEndDateAction, setUploadedDateFilterStartDateAction, setUploadedDateFilterTypeAction } from "~/store/filters/actions";
import { uploadedDateFilterDateTypeSelector, uploadedDateFilterEndDateSelector, uploadedDateFilterStartDateSelector } from "~/store/filters/selectors";
export const SingleUploadedDateFilter = /*#__PURE__*/ memo((param)=>{
    let { onApplyClick } = param;
    const dispatch = useDispatch();
    const dateType = useSelector(uploadedDateFilterDateTypeSelector);
    const startDate = useSelector(uploadedDateFilterStartDateSelector);
    const endDate = useSelector(uploadedDateFilterEndDateSelector);
    const { searchImprovements } = useTemporaryFeatureFlags();
    const onDateTypeChange = useCallback((type)=>{
        dispatch(setUploadedDateFilterTypeAction({
            type
        }));
    }, [
        dispatch
    ]);
    const onStartDateChange = useCallback((date)=>{
        if (Array.isArray(date)) return;
        dispatch(setUploadedDateFilterStartDateAction({
            startDate: date
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    const onEndDateChange = useCallback((date)=>{
        if (Array.isArray(date)) return;
        dispatch(setUploadedDateFilterEndDateAction({
            endDate: date
        }));
        if (searchImprovements) {
            onApplyClick();
        }
    }, [
        dispatch,
        onApplyClick,
        searchImprovements
    ]);
    return /*#__PURE__*/ _jsx(SingleFilterContainer, {
        currentFilter: "dateUploaded",
        onApplyClick: onApplyClick,
        children: /*#__PURE__*/ _jsx(UploadedDateFilter, {
            startDate: startDate,
            endDate: endDate,
            dateType: dateType,
            onStartDateChange: onStartDateChange,
            onEndDateChange: onEndDateChange,
            onTypeChange: onDateTypeChange
        })
    });
});
SingleUploadedDateFilter.displayName = "SingleUploadedDateFilter";
